import { Device } from 'src/models/Device';
import { Interest } from 'src/models/Interest';
import { UiError } from 'src/errors';
import { ImageIcon } from 'src/ui-models/Icon';
import { ERROR_MESSAGES, STREAM_MAP_WITH_ICON } from './constants';

export const getStreamIcon = (streamId: string): string => {
  if (!(streamId in STREAM_MAP_WITH_ICON)) {
    throw new UiError({
      message: ERROR_MESSAGES.missingIcon(streamId),
      context: {
        streamId,
        availableStreamIds: Object.keys(STREAM_MAP_WITH_ICON),
      },
    });
  }

  return STREAM_MAP_WITH_ICON[streamId as keyof typeof STREAM_MAP_WITH_ICON];
};

export const mapDevicesToIcons = (devices: Device[] | undefined): ImageIcon[] => {
  if (!devices || devices.length === 0) {
    return [];
  }

  return devices.map((item: Device) => {
    return {
      imgUrl: item.logoUrl,
      name: item.name,
    } as ImageIcon;
  });
};

export const mapInterestsToIcons = (interests: Interest[] | undefined): ImageIcon[] => {
  if (!interests || interests.length === 0) {
    return [];
  }

  return interests.map(
    (stream: Interest) =>
      ({
        imgUrl: getStreamIcon(stream.streamId),
        name: stream.name,
      } as ImageIcon),
  );
};
